import { render } from "./EditUserPassModal.vue?vue&type=template&id=b53d69ca&ts=true"
import script from "./EditUserPassModal.vue?vue&type=script&lang=ts"
export * from "./EditUserPassModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__